<template>
  <v-container fluid class="pa-0">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("oem_stock_watchlist.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-autocomplete
        v-if="isInstitutionSelectorRole"
        v-model="institution"
        :items="institutions"
        :loading="loadingInstitution"
        :label="$t('parts.advanced_search.institution')"
        item-title="title"
        item-value="_id"
        flat
        variant="solo"
        color="red-darken-1"
        hide-details
        class="hidden-sm-and-down institution-select"
        clearable
      />
      <v-switch
        v-model="belowOnly"
        :label="$t('oem_stock_watchlist.filter_below_minimum')"
        color="white"
        hide-details
        class="hidden-sm-and-down ml-2"
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        v-if="canAdd"
        color="grey-darken-4"
        variant="flat"
        class="mx-1"
        @click="newEntry"
      >
        {{ $t("oem_stock_watchlist.add") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-alert :model-value="alert.value" type="error" class="ma-0">
      {{ alert.message }}
    </v-alert>

    <v-alert
      v-if="isInstitutionSelectorRole && !institution"
      :model-value="true"
      type="info"
      variant="tonal"
      class="ma-4"
    >
      {{ $t("oem_stock_watchlist.select_institution_hint") }}
    </v-alert>

    <edit-dialog
      v-if="canModify"
      ref="editDialog"
      :institution-id="effectiveInstitutionId"
      @close="getWatchlist"
    />

    <datatable
      ref="datatable"
      :below-only="belowOnly"
      :institution-id="effectiveInstitutionId"
      @edit="editEntry"
      @error="showError"
    />
  </v-container>
</template>

<script>
import getRequest from "../api/getRequest";
import Datatable from "@/components/OemStockWatchlist/datatable.vue";
import EditDialog from "@/components/OemStockWatchlist/dialog.vue";

const INSTITUTION_SELECTOR_ROLES = ["LekoAdmin", "SuperAdmin"];

export default {
  components: {
    datatable: Datatable,
    "edit-dialog": EditDialog,
  },
  data: () => ({
    belowOnly: false,
    institution: null,
    institutions: [],
    loadingInstitution: false,
    alert: {
      value: false,
      message: "",
    },
  }),
  computed: {
    isInstitutionSelectorRole() {
      return INSTITUTION_SELECTOR_ROLES.includes(this.$store.getters.role);
    },
    canAdd() {
      return !this.isInstitutionSelectorRole;
    },
    canModify() {
      return !this.isInstitutionSelectorRole;
    },
    effectiveInstitutionId() {
      if (this.isInstitutionSelectorRole) {
        return this.institution;
      }
      return this.$store.getters.institutionId;
    },
  },
  watch: {
    institution() {
      this.getWatchlist();
    },
  },
  mounted() {
    if (this.isInstitutionSelectorRole) {
      this.getInstitutions();
    }
  },
  methods: {
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions || [];
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },
    newEntry() {
      this.$refs.editDialog.open(false, null);
    },
    editEntry(data) {
      if (!this.canModify) return;
      this.$refs.editDialog.open(true, data);
    },
    getWatchlist() {
      this.$refs.datatable.getWatchlist();
    },
    showError(error) {
      const message =
        error?.response?.data?.message || "Something went wrong";
      this.alert = { value: true, message };
      setTimeout(() => {
        this.alert = { value: false, message: "" };
      }, 3000);
    },
  },
};
</script>

<style scoped>
.institution-select {
  max-width: 280px;
  min-width: 200px;
}
</style>
